<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="975px"
    :before-close="handleClose">
    <div class="font12">
      <div class="leftBlueline">基本信息</div>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">订单号</span>
            <span class="color99 ">{{dataInfo.orderId}}</span>
        </el-row>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">国家</span>
            <span class="color99 " >{{dataInfo.countryCode == 'GB'?'英国':dataInfo.countryCode == 'EU'?'欧盟':'-'}}</span>
        </el-row>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">业务类型</span>
            <span class="color99 ">授权代理</span>
        </el-row>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">主体</span>
            <span class="color99 " v-if="dataInfo.companyInfo">{{dataInfo.companyInfo.cnName}}</span>
        </el-row>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">注册邮箱</span>
            <span class="color99 " v-if="dataInfo.tenant">{{dataInfo.tenant.name}}</span>
        </el-row>
        <el-row class="orderInfo-item">
            <span class="width60 displayIb marRight80">授权代理</span>
            <span class="color99 " v-if="dataInfo.taxAgentEntity">{{dataInfo.taxAgentEntity.name}}</span>
        </el-row>
      <div  class="leftBlueline margBottom20 marTop20">审核结果</div>
      <el-row  type="flex" class="flex-wrap font12 margBottom20">
        <el-radio-group v-model="radio">
          <el-radio :label="true">审核通过</el-radio>
          <el-radio :label="false">审核不通过</el-radio>
        </el-radio-group>
      </el-row>
    </div>
    <el-row slot="footer" class="dialog-footer marTop20" style="text-align: center">
      <el-button class="width100" size="small" type="primary" @click="handleSubmit">确定</el-button>
      <el-button class="width100" size="small" @click="dialogVisible = false;visibleStart = false">关 闭</el-button>
    </el-row>
    <!--查看大图组件-->
    <show-img ref="showImg" :imgIdList="imgIdList" :imgId="imgId"></show-img>
  </el-dialog>
</template>

<script>
import upLoad from '@/components/upload/index'
import AreaCode from '@/components/AreaCode';
import showImg from '@/components/upload/showImg.vue'
export default {
  name: 'addBuy',
  components:{
    upLoad,
    AreaCode,
    showImg
  },
  data () {
    return {
      radio:false,
      title:'审核',
      dialogVisible:false,
      registerVisible:false,
      dataInfo:{},
      radio:true,
      labelPosition:'top',
      img:'',
      imgId:[],
      imgIdList:[],
      shopLists:[],
      type:'order'
    }
  },
  methods: {
      //查看大图
    openView (src, name) {
      let imgIdList = []
      const imgType = ['.jpg', '.png','.jpeg', '.JPG', '.PNG','.JPEG']
      const hz = '.' + src.split('.')[src.split('.').length - 1]
      let url = src
      if (url.indexOf('http://') == -1 && url.indexOf('https://') == -1) url = '/Admin/' + src

      if (imgType.indexOf(hz) !== -1) {
          let img = {
              id: src,
              name: name
          }
          imgIdList.push(img)
          this.imgId = src

          this.imgIdList = imgIdList
          this.$refs.showImg.isShowBigImg = true
      } else {
          if (url.indexOf('http://') == -1 && url.indexOf('https://') == -1) return this.commonJs.Export(url, (name + hz))
          this.commonJs.DownLoadImg(url).then(res => {
              if(res){
                this.commonJs.Export(url, (name + hz))
              }
          }).catch(error => {
              this.$message({type: 'error', message: '下载失败'})
          });
      }
    },
    show(oid,type){
      this.remark = ''
      this.radio = true
      this.type = type
      console.log(this.type)
      this.getOrderDetail(oid)
      this.dialogVisible = true
    },
    // 注册邮箱
    registerEmail(){
      this.registerVisible = true
    },
    getOrderDetail(oid){
      this.ajax.get(`/EURepOrder/${oid}`,'','vatService').then((res) => {
          this.dataInfo = res.data
      })
    },
    handleSubmit(){
        if(this.type == 'order'){
          this.orderSub()
        }else{
          this.productSub()
        }
    },
    orderSub(){
      if(!this.radio) return  this.$router.push({ path: `/eneurList/abnormal`, query: { id : this.dataInfo.orderId } })
        let params = {
          isConfirm: this.radio,
          orderId:this.dataInfo.orderId,
        }
        this.ajax.put(`/EURepOrder/audit/${this.dataInfo.orderId}`,params,'vatService').then(res=>{
            if(res){
              this.$message({type:'success',message:'操作成功'})
              this.dialogVisible = false;
              this.$router.push({ path: `/eneurList`})
            }
        })
    },
    productSub(){
      if(!this.radio) return  this.$router.push({ path: `/eneurList/newAbnormal`, query: { id : this.dataInfo.orderId } })
        let params = {
          isConfirm: this.radio,
          orderId:this.dataInfo.orderId,
        }
        this.ajax.put(`/EURepOrder/audit/${this.dataInfo.orderId}/newproduct`,params,'vatService').then(res=>{
            if(res){
              this.$message({type:'success',message:'操作成功'})
              this.dialogVisible = false;
              this.$router.push({ path: `/eneurList`})
            }
        })
    },
    handleClose(done) {
      done();
    },
  }
}
</script>

<style scoped>
.margBottom15{
  margin-bottom: 15px;
}
/deep/.el-form-item--small .el-form-item__label{
  padding: 0!important;
}
.flex-box{
  width: 100%;
}
.marLF10{
  margin-left: 10px;
}
.font12{
  font-size: 12px;
}
.inline-box{
  width: 49%;
  display: inline-block;
  font-size: 12px;
  position: relative;
}
.btip{
  position: absolute;
  bottom: 8px;
  left: 0;
}
.tip{
  color: #999;
  font-size: 12px;
}
.orderInfo-item {
        display: inline-flex;
        margin-top: 20px;
        width: 33%;
        padding-right: 40px;
  }
  .width60 {
    display: inline-block;
    width: 80px;
  }
  .marRight80{
    margin-right: 15px;
  }
  .margBottom20{
    margin-bottom: 20px;
  }
  /* 1440屏以下，去掉侧边栏的宽度 */
    @media screen and (max-width: 1421px) {
        .orderInfo-item {
            width: 33%;
        }
        .marRight80 {
            margin-right: 15px !important;
        }
    }

    /deep/ .el-input.is-disabled .el-input__inner {
        cursor: revert;
    }
    @media only screen and (max-width: 1280px) {
        .orderInfo-item{
            margin-top: 15px;
        }
        .marRight80 {
            margin-right: 30px !important;
        }
        .right-icon > svg {
            font-size: 62px !important;
        }
    }
    .w-space{
      white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/compliance/component/examine.vue